export const GET_PROVIDERS_REQUEST = "GET_PROVIDERS_REQUEST";
export const GET_PROVIDERS_RESPONSE = "GET_PROVIDERS_RESPONSE";

export const ADD_PROVIDER_REQUEST = "ADD_PROVIDER_REQUEST";

export const EDIT_PROVIDER_REQUEST = "EDIT_PROVIDER_REQUEST";

export const GET_PROVIDER_DETAILS_REQUEST = "GET_PROVIDER_DETAILS_REQUEST";
export const GET_PROVIDER_DETAILS_RESPONSE = "GET_PROVIDER_DETAILS_RESPONSE";

export const DELETE_PROVIDER_REQUEST = "DELETE_PROVIDER_REQUEST";

export const GET_GENERATED_PASSWORD_REQUEST = "GET_GENERATED_PASSWORD_REQUEST";
export const GET_GENERATED_PASSWORD_RESPONSE = "GET_GENERATED_PASSWORD_RESPONSE";

export const GET_REQUEST_STATUS = "GET_REQUEST_STATUS";
